module.exports = __webpack_public_path__ + "cima-preu.svg?50bfd4daccaa969cccc82fc47d3bf157";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons/cima-preu.svg
// module id = 203
// module chunks = 0